import { cloneElement, ReactElement } from 'react';
import { BooleanInput } from 'react-admin';

import { BoListQueryBase } from '@Common/types/bo/bo_list_query';

export type FilterList<T extends BoListQueryBase> = Record<
  keyof Exclude<T['filter'], undefined>,
  ReactElement
>;

export const createFilters = <T extends BoListQueryBase>(filterList: FilterList<T>) =>
  Object.entries(filterList).map(([source, element]) => {
    const props = {
      ...element.props,
      source,
    };

    // Set default value for boolean input to prevent undefined filter
    // value when filter is added
    if (element.type === BooleanInput && element.props.defaultValue === undefined) {
      props.defaultValue = false;
    }

    return cloneElement(element, props);
  });
